import { render, staticRenderFns } from "./HarclarInfo.vue?vue&type=template&id=1fb6387b"
import script from "./HarclarInfo.vue?vue&type=script&lang=ts"
export * from "./HarclarInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports